import { all, fork, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  ACTION_REQUEST_CLUES,
  ACTION_REQUEST_PUT_CLUE,
  ACTION_SET_CLUE_DETAIL,
  actionSetClueDetail,
  getCluesAPI,
  getTreasureDetailAPI,
  putClueAPI,
  REQUEST_CLUES_FAILURE,
  REQUEST_PUT_CLUE_FAILURE,
  REQUEST_PUT_CLUE_SUCCESS,
  REQUEST_TREASURE_DETAIL_FAILURE,
  CREATE_CLUE_REQUEST, 
  CREATE_CLUE_SUCCESS, 
  CREATE_CLUE_FAILURE 
} from '.';
import { showToastAlert } from '../app';
import { fetchUserInfo } from '../auth';

function* loadClueData() {
  const { clue } = yield select();
  const { clueFilter } = clue;
  yield put(getCluesAPI(clueFilter));
}

function* getClue() {
  yield takeLatest([ACTION_REQUEST_CLUES], function* () {
    const { clue } = yield select();
    const { clueFilter } = clue;
    yield put(getCluesAPI(clueFilter));
  });

  yield takeLatest([REQUEST_CLUES_FAILURE], function* (action) {
    yield put(showToastAlert(action?.payload?.error?.message || 'Failed to get clues!', 'error'));
  });

  yield takeLatest([ACTION_SET_CLUE_DETAIL], function* (action) {
    const treasureId = action?.payload?.treasureId;
    if (treasureId) {
      yield put(getTreasureDetailAPI(treasureId));
    }
  });

  // yield takeLatest([REQUEST_TREASURE_DETAIL_FAILURE], function* (action) {
  //   yield put(showToastAlert(action?.payload?.error?.message || 'Failed to get clue!', 'error'));
  // });
}

function* updateClue() {

  yield takeLatest([ACTION_REQUEST_PUT_CLUE], function* (action) {
    yield put(putClueAPI(action?.payload));
  });
  
  yield takeLatest([REQUEST_PUT_CLUE_SUCCESS], function* (action) {
    const updatedClue = action?.payload?.daya;
    const { clue } = yield select();
    const { clueFilter } = clue;
    yield put(getCluesAPI(clueFilter));
    yield put(actionSetClueDetail(updatedClue));
  });
  
  yield takeLatest([REQUEST_PUT_CLUE_FAILURE], function* (action) {
    yield put(showToastAlert(action?.payload?.error?.message || 'Failed to update clue!', 'error'));
  });

  yield takeLatest([ACTION_REQUEST_PUT_CLUE], function* (action) {
    yield put(putClueAPI(action?.payload));
  });

  yield takeLatest([REQUEST_PUT_CLUE_SUCCESS], function* (action) {
    const updatedClue = action?.payload?.daya;
    const { clue } = yield select();
    const { clueFilter } = clue;
    yield put(getCluesAPI(clueFilter));
    yield put(actionSetClueDetail(updatedClue));
  });

  yield takeLatest([REQUEST_PUT_CLUE_FAILURE], function* (action) {
    yield put(showToastAlert(action?.payload?.error?.message || 'Failed to update clue!', 'error'));
  });
}

function* handleCreateClue() {
  yield takeLatest([CREATE_CLUE_REQUEST], function* (action) {
    yield put(showToastAlert('Creating clue...'));
  });

  yield takeLatest([CREATE_CLUE_SUCCESS], function* () {
    yield put(showToastAlert('Clue created successfully!', 'success'));
    yield new Promise(resolve => setTimeout(resolve, 2000));
    yield put(fetchUserInfo())
  });

  yield takeLatest([CREATE_CLUE_FAILURE], function* (action) {
    yield put(showToastAlert(action?.payload?.error?.message || 'Failed to create clue!', 'error'));
  });
}

export function* loadCluePage() {
  yield all([fork(loadClueData), fork(getClue), fork(updateClue)]);
}

export function* createClue() {
  yield all([fork(handleCreateClue)]);
}

